/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { TransactionOverviewViewModel } from 'src/types/view-models/transaction-overview.view.model';
import NavigationService from '../../../../services/navigation.service';
import FormatService from '../../../../services/format.service';
import { TransactionModel } from 'src/types/transaction.model';
import { AccountModel } from 'src/types/account.model';
import Anchor from '../../atoms/anchor/Anchor';
import ValueCapsule from './ValueCapsule';
import { ValueVariants } from 'src/types/value-variants.enum';

// styles
import styles from './TransactionOverview.module.scss';
import Typography from '../../../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';

export default class TransactionOverview extends Component<TransactionOverviewViewModel> {
    public override render(): ReactComponentElement<any> {
        const transactionModel: TransactionModel = this.props.transactionModel;
        const account: AccountModel = this.props.account;
        const amountType: ValueVariants = this.props.expense ? ValueVariants.NEGATIVE : ValueVariants.POSITIVE;
        const showNegativeSign: boolean = amountType === ValueVariants.NEGATIVE;

        return (
            <div className={styles.transactionOverview} data-cy={Selectors.PlanAhead.TRANSACTION_OVERVIEW}>
                <div className={styles.transactionInfo}>
                    <Anchor
                        onClick={() => {
                            void NavigationService.goTo(
                                this.props.history,
                                `/drawer/transactions?start=${this.props.startDate}&end=${this.props.endDate}&search=${transactionModel.name}`,
                                'Transactions Drawer'
                            );
                        }}
                        data-cy={Selectors.PlanAhead.TRANSACTION_OVERVIEW_TITLE}
                        typographyProps={{
                            className: styles.transactionTitle,
                            variant: TypographyVariants.BODY
                        }}
                    >
                        {transactionModel.name.toLowerCase().charAt(0).toUpperCase() + transactionModel.name.slice(1)}
                    </Anchor>
                    <Typography variant={TypographyVariants.CAPTION}>
                        {account.name.toLowerCase().charAt(0).toUpperCase() + account.name.slice(1)} (#{account.id})
                    </Typography>
                </div>
                <Typography variant={TypographyVariants.SUBTEXT}>
                    {FormatService.formatDate(transactionModel.date)}
                </Typography>
                <ValueCapsule
                    amount={transactionModel.amount}
                    amountType={amountType}
                    showNegativeSign={showNegativeSign}
                />
            </div>
        );
    }
}
